import { ListItem, ListItemIcon, ListItemText, Tooltip, useTheme } from '@mui/material';
import React, { forwardRef, useMemo } from 'react';

import { LinkProps, NavLink } from 'react-router-dom';
interface ListItemLinkProps {
    icon?: React.ReactElement;
    primary: string;
    to: string;
    tooltip?: string;
}

export function ListItemLink({ icon, primary, to, tooltip }: ListItemLinkProps) {
    const theme = useTheme();

    const renderLink = useMemo(() => {
        const comp = forwardRef<HTMLAnchorElement, Omit<LinkProps, 'to'>>((itemProps, ref) => (
            <NavLink
                to={to}
                ref={ref}
                {...itemProps}
                style={isActive => ({
                    '& .MuiListItemIconRoot': {
                        color: theme.palette.primary.main
                    },
                    backgroundColor: isActive ? 'rgba(0, 0, 0, 0.08)' : 'initial'
                })}
            />
        ));
        comp.displayName = 'navlink';
        return comp;
    }, [to, theme.palette.primary.main]);

    return (
        <li>
            <Tooltip title={tooltip ?? ''} placement="right">
                <ListItem button component={renderLink}>
                    {icon && <ListItemIcon>{icon}</ListItemIcon>}
                    <ListItemText primary={primary} />
                </ListItem>
            </Tooltip>
        </li>
    );
}
